class Controller {
  constructor($injector, $stateParams, Sections) {
    "ngInject";
    this.$injector = $injector;
    this.$stateParams = $stateParams;
    this.CountryResource = $injector.get("Country");
    this.CountryTransforms = $injector.get("CountryTransforms");
    this.Events = $injector.get("Events");
    this.onUpdateEvent = this.Events.getUpdateEvent("country");
    this.onUpdateFeatureFlags = this.Events.getUpdateEvent(
      "countryFeatureFlag"
    );
    this.showSuccessMessage = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.sections = Sections.settingsSections;
  }
  $onInit() {
    this.CountryResource.get(this.$stateParams.id).$promise.then((response) => {
      this.country = this.CountryTransforms.justify(response);
    });

    const updateFeatureFlags = () => {
      this.CountryResource.updateFeatureFlags(this.$stateParams.id, {
        feature_flags: {
          travel_website_support: {
            enabled: this.country.feature_flags.travel_website_support.enabled
              .value,
          },
          travel_aggregator_support: {
            enabled: this.country.feature_flags.travel_aggregator_support
              .enabled.value,
          },
        },
      }).$promise.then(
        (response) => {
          this.country.feature_flags.travel_website_support.enabled.isDisabled = true;
          this.country.feature_flags.travel_aggregator_support.enabled.isDisabled = true;
          this.Events.emit(this.showSuccessMessage, {
            message: "Country feature flags updated successfully",
          });
          this.country = this.CountryTransforms.justify(response);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };
    this.Events.on(this.onUpdateFeatureFlags, updateFeatureFlags);

    const onUpdate = (options) => {
      const { key, value } = options;
      this.CountryResource.update(this.$stateParams.id, {
        [key]: value,
      }).$promise.then(() => {
        this.country[key].isDisabled = true;
        this.Events.emit(this.showSuccessMessage, {
          message: "Country updated successfully",
        });
      });
    };
    this.Events.on(this.onUpdateEvent, onUpdate);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/country/country.controller.js